import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import DataTable from "react-data-table-component";
import { useEffect, useState } from "react";
import { adminConfig } from "../../../utils/adminConfig";
import { useHistory } from "react-router-dom";
const columns = [
  {
    name: "Certificate ID",
    selector: (row) => row.certificateId,
    sortable: true,
    // width: "100px",
  },
  {
    name: "Image",
    selector: (row) => row.certificateImg,
    sortable: true,
    // width: "150px",
  },
  {
    name: "Certificate Title",
    selector: (row) => row.certificateTitle,
    sortable: true,
    // width: "200px",
  },
  {
    name: "White Level Certificate",
    selector: (row) => row.isHasWhiteLevel,
    sortable: true,
    // width: "450px",
  },
  {
    name: "Certificate Price",
    selector: (row) => row.certificatePrice,
    sortable: true,
    // width: "450px",
  },
  // {
  //   name: "Default Message",
  //   selector: (row) => row.message,
  //   sortable: true,
  //   width: "450px",
  // },
  // {
  //   name: "Action",
  //   selector: (row) => row.action,
  //   sortable: true,
  //   width: "200px",
  // },
];

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
      padding: "10px",
    },
  },
};

export default function CertificateList() {
  const navigate = useHistory();
  const [loading, setLoading] = useState(false);
  const [certis, setCertis] = useState([]);

  const allCertis = () => {
    let allCertis =
      certis.length > 0 &&
      certis.map((item, i) => {
        return {
          certificateId: item.certificateId,
          certificateImg: (
            <div className="cert_list_image">
              <img src={item.certificateImg} alt="" />
            </div>
          ),
          certificateTitle: item.certificateTitle,
          isHasWhiteLevel: (item?.isHasWhiteLevel) ? "Yes" : "No",
          certificatePrice: item.certificatePrice

          // action: (
          //   <div className="action_button">
          //     {/* <button type="button" className="edit_but">
          //       Edit
          //     </button> */}
          //     <button type="button" className="act_del_but">
          //       Delete
          //     </button>
          //   </div>
          // ),
        };
      });

    return allCertis;
  };
  useEffect(() => {
    getCertis();
  }, []);

  const getCertis = () => {
    setLoading(true);

    axios
      .get(`/all-admin-certificates`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          setCertis(res.data.data);
          setLoading(false);
        } else {
          message.error("Data Not Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="cert_det_inner">
              <h2>Certificate Listing</h2>
              <div className="row">
                <div className="col-md-12 text-right mb-3">
                  <button type="button" className="btn btn-primary" onClick={() => navigate.push("/add-certificate")}>Add / Update Certificate</button>
                </div>
              </div>
              {certis.length > 0 && (
                <DataTable
                  columns={columns}
                  data={allCertis()}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}
